export default {
  thematics: [
    {
      id: 1,
      title: "Smart Office",
      ref: "smartoffice",
      description: "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship."
    },
    {
      id: 2,
      title: "Eclectic Design",
      ref: "eclectic",
      description: "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship."
    },
    {
      id: 3,
      title: "Domestic Outdoor lighting",
      ref: "dol",
      description: "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics."
    },
    {
      id: 4,
      title: "Urban Outdoor lighting",
      ref: "uol",
      description: "Highly innovative interiors: water sustainability according to Salotto NY."
    },
    {
      id: 5,
      title: "Home Entertainment",
      ref: "homent",
      description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
    },
    {
      id: 6,
      title: "Umbrellas and Pergolas",
      ref: "umbrella",
      description: "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces."
    },
    {
      id: 7,
      title: "Wallpaper",
      ref: "wallpaper",
      description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
    },
    {
      id: 8,
      title: "Rugs",
      ref: "rug",
      description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
    },
  ],
};
